import { render, staticRenderFns } from "./OrgStructureView.vue?vue&type=template&id=bed2e832"
import script from "./OrgStructureView.vue?vue&type=script&lang=js"
export * from "./OrgStructureView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports